import axios from "axios";
import type { ApiResponse } from "@entrilia/shared/api/types.ts";

export const getPreconditionFailedMessage = (error: unknown): string | undefined => {
  const apiError = axios.isAxiosError<Partial<ApiResponse<unknown>> | undefined>(error)
    ? error.response?.data?.error
    : undefined;
  return apiError?.type === "PreconditionFailed" ? apiError.message : undefined;
};
